<script setup lang="ts">
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { createCompetition } from '../../api/competitions'
import type { ApiError } from '../../api/client'
import CInput from '../../components/CInput.vue'
import CButton from '../../components/CButton.vue'
import GFormErrors from '../../components/GFormErrors.vue'

const router = useRouter()

const name = ref('')
const errors = ref<{ msg: string; path?: string }[]>([])
const submitting = ref(false)

async function submit() {
	errors.value = []
	submitting.value = true

	try {
		const comp = await createCompetition(name.value)
		router.push(`/competitions/${comp.id}`)
	} catch (e) {
		errors.value = (e as ApiError).errors ?? [{ msg: String(e) }]
	} finally {
		submitting.value = false
	}
}
</script>

<template>
	<main class="l-row l-stack">
		<GFormErrors :errors="errors" />

		<h1>Start a new Competition</h1>

		<p>Documentation to be written</p>

		<form class="l-stack" @submit.prevent="submit">
			<CInput v-model="name" type="text" name="name" title="Competition Name" :wide="true" />
			<CButton type="submit" :disabled="submitting">Create</CButton>
		</form>
	</main>
</template>
